import {getMinutes, sortBy, union, createSelector} from 'helpers';
import {today, date} from 'store/common';
import {current} from 'store/activities/selectors';

const isToday = createSelector(
  [ today, date ],
  ( today, date ) => date.isSame(today),
  { memoizeOptions: { maxSize: 2 } },
);

const days = [
  createSelector([today, current.byDate], (today, byDate) => byDate[today.clone().subtract(1, 'day').unix()]),
  createSelector([today, current.byDate], (today, byDate) => byDate[today.clone().subtract(2, 'day').unix()]),
  createSelector([today, current.byDate], (today, byDate) => byDate[today.clone().subtract(3, 'day').unix()]),
];

export const recentlyMissed = createSelector(
  [ isToday, ...days ],
  ( isToday, ...days ) => isToday && union(
    sortBy(days[0], ({ time }) => getMinutes(time), 'name'),
    sortBy(days[1], ({ time }) => getMinutes(time), 'name'),
    sortBy(days[2], ({ time }) => getMinutes(time), 'name'),
  ).filter(({ status }) => status == 'Not Started'),
  { memoizeOptions: { maxSize: 2 } },
);
